import { render, staticRenderFns } from "./CompanyEditUserModal.vue?vue&type=template&id=55e8f53d&"
import script from "./CompanyEditUserModal.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditUserModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55e8f53d')) {
      api.createRecord('55e8f53d', component.options)
    } else {
      api.reload('55e8f53d', component.options)
    }
    module.hot.accept("./CompanyEditUserModal.vue?vue&type=template&id=55e8f53d&", function () {
      api.rerender('55e8f53d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditUserModal.vue"
export default component.exports